import { getCookie } from './cookie';
import axios from 'axios';
import { Decimal } from 'decimal.js';
const CryptoJS = require('crypto-js');
// TODO:
// import createAxios from '@framework/http';
// const axios = createAxios({ keys: 'utils.download', DEBUG: process.env.VUE_APP_NODE_ENV !== 'production' });

export function storage(key, val) {
    const argsLength = arguments.length;
    try {
        if (argsLength === 1) {
            // 读取数据
            const valStr = localStorage && localStorage.getItem(key);
            return JSON.parse(valStr);
        }
        // 变更数据
        localStorage && localStorage.setItem(key, JSON.stringify(val));
    } catch (err) {
        return {};
    }
}

export function getDeepValue(data: any, keySquence: string[]) {
    const len = keySquence.length;
    const reducer = (accumulator: any, key: string, idx: number) => {
        // eslint-disable-next-line
        return accumulator[key] ? accumulator[key] : idx === len - 1 ? undefined : {};
    };
    return keySquence.reduce(reducer, data || {});
}
// 不完整的模拟node util.format
// http://git.corp.kuaishou.com/ks/kuaishou-frontend/blob/master/www/mobile/src/static/js/lib/util.js#L218
function _format() {
    const target = arguments[0];
    if (!target || typeof target !== 'string') {
        return target;
    }
    // @ts-ignore
    const replacer = [].splice.call(arguments, 1);
    let index = 0;
    return target.replace(/(%s)/g, function () {
        // eslint-disable-next-line
        return replacer[index] !== undefined ? replacer[index++] : arguments[0];
    });
}

/**
 * 格式化处理 ksnode-language 字符串中的 %s, ${0} 等占位符
 * 自定义格式化函数, 为什么要自定义？因为有时候字符串里的替换符是%s, 有的时候是${0}, ${0}, 在此统一处理一下
 *
 * @param      {Array}   args[0]: 要格式化的字符串， args[1] ... args[n] 待替换的变量
 * @return     {string}  { 格式化后的字符串 }
 */
export function ksLanguageFormat(...args) {
    let targetStr = args[0];

    if (!targetStr) {
        return '';
    }

    if (-1 !== targetStr.indexOf('%s')) {
        targetStr = _format.apply(null, args);
    }

    for (let i = 1; i < args.length; i++) {
        const replacement = '${' + (i - 1) + '}';
        if (-1 !== targetStr.indexOf(replacement)) {
            // args[1] 对应的是 ${0}, args[2] 对应的是 ${1}, 依次类推
            // 把所有${0}全部替换为args[1]，依次类推
            targetStr = targetStr.split(replacement).join(args[i]);
        }
    }

    return targetStr;
}

/**
 * 单位转化为万，保留一位小数
 *
 * @param  {number} count 处理前的数字
 * @param  {number} unit  后缀
 * @return {string}
 */
export function numberFloorWan(count, unit = '万') {
    if (count > 9999) {
        count = new Decimal(count).div(10000);
        count = count.toFixed(1, Decimal.ROUND_DOWN) + unit;
    }
    return count;
}

/**
 * 分转化为元
 *
 * @param  {number} count 单位为分的数字
 * @return {number}
 */
export function fen2yuan(count) {
    return new Decimal(count).div(100) || 0;
}

export function getQuery(name) {
    const search = location.search;
    if (!name || !search) {
        return;
    }
    const result = search.match(new RegExp(`[?&]${name}=([^&]+)`, 'i'));
    if (result !== null && result.length > 0) {
        // eslint-disable-next-line consistent-return
        return result[1];
    }
}

/**
 * 固定数字位数为两位
 *
 * @param  {number} num 处理前的数字
 * @return {string}  { 格式化后的字符串 }
 */
export function toFixed(num) {
    return num < 10 ? '0' + num : num;
}

/**
 * 转换时间格式
 *
 * @param  {number} time 转换前的时间戳
 * @return {string}  { 格式化后的字符串 }
 */
export function converteTime(time) {
    if (!time) {
        return '-';
    }
    const date = new Date(time);
    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = date.getDate() + ' ';
    const h = date.getHours() + ':';
    const m = date.getMinutes() + ':';
    const s = date.getSeconds();
    return Y + M + D + h + m + s;
}

/**
 * 返回本地时间，单位秒
 *
 * @return {number}  { 返回本地时间 }
 */
export function getLocalTime(): number {
    return Math.floor(new Date().getTime() / 1000);
}

/**
 * 程序延迟time ms
 *
 * @param  {number} time 需要延迟的时间 单位是ms
 */
export function sleep(time) {
    return new Promise(resolve => {
        setTimeout(resolve, time);
    });
}

/**
 * 产生min到max的随机时间,向下舍入
 *
 * @return {number}  { min到max的随机时间 }
 */
export function random(min = 0, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

export function preLoad(src) {
    const img = new Image();
    img.src = src;
}

export function toggleBodyScroll(b) {
    if (b) {
        document.body.style.overflowY = 'hidden';
        document.body.style.height = '100vh';
        document.body.style.position = 'fixed';
    } else {
        document.body.style.overflowY = 'auto';
        document.body.style.height = 'auto';
        document.body.style.position = 'static';
    }
}

export function dataURItoBlob({ type, base64 }) {
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type });
}

export function getUserId(cookieStr) {
    // token 中会存在上一次登录的账号的userid，不准确
    // const token = getCookie('token', cookieStr);
    // if (token) {
    //     return token.split('-')[1];
    // }
    return getCookie('userId', cookieStr) || getCookie('ud', cookieStr);
}

export function valid(userId = '', strategy = '') {
    let result = false;
    try {
        const strategyArray = strategy.split(';');
        const userIdInt = parseInt(userId);
        const mold = strategyArray[0];
        const value = userIdInt % parseInt(mold);
        const ranges = strategyArray[1].split(',');
        const whitelist = strategyArray[2].split(',');
        const blacklist = strategyArray[3].split(',');
        const reg = /-/;

        if (blacklist.includes(userId)) {
            result = false;
        } else if (whitelist.includes(userId)) {
            result = true;
        } else {
            for (let i = 0; i < ranges.length; i++) {
                if (reg.test(ranges[i])) {
                    const temp = ranges[i].split('-');
                    result = value >= parseInt(temp[0]) && value <= parseInt(temp[1]);
                } else if (parseInt(ranges[i]) == value) {
                    result = true;
                }
                if (result) {
                    break;
                }
            }
        }
        return result;
    } catch (e) {
        return result;
    }
}
export function blobToFile(blob, fileName) {
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return blob;
}

export function throttle(fn: () => void, wait: number) {
    let timer = null as any;
    return function () {
        const context: any = this;
        const args: any = arguments;
        if (!timer) {
            timer = setTimeout(function () {
                fn.apply(context, args);
                timer = null;
            }, wait);
        }
    };
}

export function exportFile(url: string, params: {},canAsyncExportOrder=false) {
    const strArr = [] as string[];

    for (const key in params) {
        if ((params as any)[key] === undefined || (params as any)[key] === null) {
            continue;
        }
        if (params[key as keyof typeof params]) {
            strArr.push(`${key}=${params[key as keyof typeof params]}`);
        }
    }
    //灰度的异步导出能力
    const exportUrl = `${url}?${strArr.join('&')}`;
    if(!canAsyncExportOrder){
        window.open(exportUrl);
    }else{
        axios.get(exportUrl);
    }
}

export function downloadExcel(url, method = 'get') {
    axios({
        method,
        url: url,
        data: {},
        responseType: 'blob',
    })
        .then(res => {
            const data = res.data;

            if (!data) {
                return;
            }
            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.setAttribute('download', '券包模板.xlsx');
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
        })
        .catch(error => {
            console.log(error);
        });
}
export function isNumber(value) {
    return /^\d*$/.test(value);
}

/**
 * 下面是向支付中台获取authToken，
 */
const passTokenDomain = {
    test: 'https://ksid.test.gifshow.com',
    online: 'https://id.kuaishou.com',
    staging: 'https://ksid-staging.corp.kuaishou.com',
};

const passTokenAxios = axios.create({
    baseURL: process.env.KS_ENV === 'prod' ? passTokenDomain.online : passTokenDomain.staging,
    withCredentials: true,
});

// 向支付中台获取AuthToken
export async function getAuthToken(sidStr) {
    const result = await passTokenAxios.post('/pass/kuaishou/login/passToken', {
        sid: sidStr,
    });
    return result;
}

/**
 * 可以根据转入的天数获取前面某天的开始与结束时间戳
 * @param {number} num 前面几天
 */
export function getStartEndTime(num = 1) {
    // 一天的毫秒数
    const MillisecondsADay = 24 * 60 * 60 * 1000 * num;
    // 今日开始时间戳
    const todayStartTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
    // 今日结束时间戳
    const todayEndTime = new Date(new Date().setHours(23, 59, 59, 999)).getTime();

    // 昨日开始时间戳
    const yesterdayStartTime = todayStartTime - MillisecondsADay;
    // 昨日结束时间戳
    const yesterdayEndTime = todayEndTime - MillisecondsADay;
    return [yesterdayStartTime, yesterdayEndTime];
}

/**
 * 数组转树形结构
 * @param {array} list 被转换的数组
 * @param {number|string} root 根节点（最外层节点）的 id
 * @return array
 */
export function arrayToTree(list, root) {
    const result: any[] = []; // 用于存放结果
    const map = {}; // 用于存放 list 下的节点

    // 1. 遍历 list，将 list 下的所有节点以 id 作为索引存入 map
    for (const item of list) {
        map[item.id] = { ...item }; // 浅拷贝
    }
    // 2. 再次遍历，将根节点放入最外层，子节点放入父节点
    for (const item of list) {
        // 3. 获取节点的 id 和 父 id
        const { id, parentId } = item; // ES6 解构赋值
        // 4. 如果是根节点，存入 result
        if (item.parentId === root) {
            result.push(map[id]);
        } else {
            if (!map[parentId]) {
                continue;
            }
            // 5. 反之，存入到父节点
            map[parentId].children ? map[parentId].children.push(map[id]) : (map[parentId].children = [map[id]]);
        }
    }
    // 将结果返回
    return result;
}

/**
 * 将树形结构三层叶子节点拍平并带上其祖先信息
 * @param {array} tree 树形结构数组
 * @return array
 */
export function toFlat(tree) {
    const result: any[] = [];
    for (let i = 0; i < tree.length; i++) {
        const firstItem = tree[i];
        const { id, permitCode, permitName, children: firstChildren = [] } = firstItem;
        const firstBaseObj = {
            firstId: id,
            firstCode: permitCode,
            firstName: permitName,
        };
        if (!firstChildren.length) {
            result.push({
                ...firstBaseObj,
                secondName: '-',
                thirdName: '-',
            });
            continue;
        }
        for (let j = 0; j < firstChildren.length; j++) {
            const secondItem = firstChildren[j];
            const { permitName: secondName, children: secondChildren = [] } = secondItem;
            if (!secondChildren.length) {
                result.push({
                    ...firstBaseObj,
                    secondName,
                    thirdName: '-',
                });
                continue;
            }
            for (let k = 0; k < secondChildren.length; k++) {
                const thirdItem = secondChildren[k];
                const { permitName: thirdName } = thirdItem;
                result.push({
                    ...firstBaseObj,
                    secondName,
                    thirdName,
                });
            }
        }
    }
    return result;
}

export const compare = (a, b) => {
    if (a.firstName !== b.firstName) {
        return a.firstName - b.firstName;
    }
    return a.secondName - b.secondName;
};

export function getRange(list, key, initLimit = []) {
    if (initLimit.length) {
        const limit = initLimit.map(item => [Number(item[0]), Number(item[1])]);
        const res = [];
        for (let i = 0; i < limit.length; i++) {
            const dic = {};
            for (let j = limit[i][0]; j <= limit[i][1]; j++) {
                if (!dic[list[j][key]]) {
                    dic[list[j][key]] = [j];
                } else {
                    dic[list[j][key]][1] = j;
                }
            }
            for (const k in dic) {
                if (dic[k].length == 1) {
                    delete dic[k];
                }
            }
            res.push(...Object.values(dic));
        }
        return res;
    }
    const dic = {};
    for (const k in list) {
        if (!dic[list[k][key]]) {
            dic[list[k][key]] = [k];
        } else {
            dic[list[k][key]][1] = k;
        }
    }
    for (const k in dic) {
        if (dic[k].length == 1) {
            delete dic[k];
        }
    }
    return Object.values(dic);
}

/**
 * 下载文件
 * @param {String} path - 下载地址/下载请求地址。
 * @param {String} name - 下载文件的名字/重命名（考虑到兼容性问题，最好加上后缀名）
 */
export const downloadFile = (path, name) => {
    const xhr = new XMLHttpRequest();
    xhr.open('get', path);
    xhr.responseType = 'blob';
    xhr.send();
    xhr.onload = function () {
        if (this.status === 200 || this.status === 304) {
            // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
            if ('msSaveOrOpenBlob' in navigator) {
                navigator.msSaveOrOpenBlob(this.response, name);
                return;
            }
            // const blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') });
            // const url = URL.createObjectURL(blob);
            const url = URL.createObjectURL(this.response);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    };
};

/**
 * 获取客服跳转前缀地址
*/
export const getCurrentHost = () => {
    let host = 'https://lbs.kuaishou.com';
    if (process.env.net_env === 'staging') {
        host = 'https://ll-mfe.staging.kuaishou.com';
    }
    if (process.env.net_env === 'prt') {
        host = 'https://ll-mfe.prt.kuaishou.com';
    }
    if (process.env.net_env === 'prod') {
        host = 'https://lbs.kuaishou.com';
    }
    return host;
};

/**
 * 字段加密
 * @param field 加密内容
 * @param key 秘钥
 * @returns 加密结果
 */
export const encryptField = (field, key) => {
    // 将字段转换为字符串
    const fieldString = JSON.stringify(field);
    // 使用AES算法进行加密
    const encrypted = CryptoJS.AES.encrypt(fieldString, key).toString();
    // 返回加密后的字段
    return encrypted;
};
